export default "__VITE_ASSET__C8c_zSI8__"